import type { AxiosException } from '../../clients/localApiAxiosErrorInterceptors';

import { createValidationException } from '../../../exceptions/exceptionUtils';
import {
    type ApiHybrisValidationError,
    type HybrisApiError,
    isApiHybrisBaseError,
} from '../../clients/hybrisErrorInterceptor';

export const hybrisFormValidationInterceptor = (
    error: AxiosException<HybrisApiError<ApiHybrisValidationError>>,
) => {
    if (!Array.isArray(error?.response.data.errors)) {
        return null;
    }

    const hybrisErrors = error.response.data.errors;

    const formValidationErrors = hybrisErrors
        .filter(
            (_error): _error is ApiHybrisValidationError =>
                isApiHybrisBaseError(_error) &&
                _error.type === 'ValidationError' &&
                _error.subjectType === 'parameter',
        )
        .map((_error) => ({
            field: _error.subject,
            friendlyMessage: _error.message,
            code: _error.type,
        }));

    if (formValidationErrors.length > 0) {
        return createValidationException(
            'HybrisValidationError',
            'HybrisValidationError',
            formValidationErrors,
        );
    }

    // pass over to next interceptor
    return null;
};
